import { useQuery } from '@tanstack/react-query';

import { publicApi } from '@/lib/api-clients/rest-client';
import { useAccountStore } from '@/store/use-account-store';

const GEO_BASE = (import.meta.env.VITE_REST_V2_URL ?? '').replace(
  '/v2/',
  '/v3/',
);

interface IpGeolocationResponse {
  requestId?: string;
  ipInfo?: {
    v4?: { geolocation?: { country?: { code?: string | null } } };
    v6?: { geolocation?: { country?: { code?: string | null } } };
  };
}

const fetchDepositGeoCountry = async (
  requestId: string,
): Promise<string | undefined> => {
  const data = await publicApi.get<IpGeolocationResponse>(
    `${GEO_BASE}fingerprint/ip-geolocation/${requestId}`,
  );

  const code =
    data?.ipInfo?.v4?.geolocation?.country?.code ??
    data?.ipInfo?.v6?.geolocation?.country?.code ??
    undefined;

  return code ? code.toUpperCase() : undefined;
};

export const useDepositGeoCountry = () => {
  const requestId = useAccountStore((state) => state.fingerprintRequestId);

  return useQuery({
    queryKey: ['deposit-geo-country', requestId],
    queryFn: () => fetchDepositGeoCountry(requestId as string),
    enabled: !!requestId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
